// removed by extract-text-webpack-plugin
module.exports = {"popover-outlet-name":"app-pages-Employees-Staff-StaffList-OutletCell-__OutletCell___iBBjG","popover":"app-pages-Employees-Staff-StaffList-OutletCell-__OutletCell___rmbf9","outlet-name":"app-pages-Employees-Staff-StaffList-OutletCell-__OutletCell___2S5Nv"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/StaffList/OutletCell/OutletCell.css
// module id = 2341
// module chunks = 0